import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { IncidentDto, IncidentPhotoDto, ParametreDto, ParametreValues, PermissionPrefix } from 'src/api/models';
import { LoaderService } from 'src/core/layouts/loader/loader.service';
import { NotificationService, TypeMessage } from 'src/core/services/notification.service';
import { EnvService } from 'src/environments/environment';
import { ControlPanelService } from 'src/states/control-panel.service';
import { Visites } from '../../../../modules/visites/state/visites.actions';
import { VisitesStore } from '../../../../modules/visites/state/visites.store';
import { BaseComponent } from '../base/base.component';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { DxGalleryComponent } from 'devextreme-angular';

@Component({
  selector: 'app-incident-photos-popup',
  templateUrl: './incident-photos-popup.component.html',
  styleUrls: ['./incident-photos-popup.component.css']
})
export class IncidentPhotosPopupComponent extends BaseComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.parametres$) parametres$: Observable<ParametreDto[]>;

  @ViewChild('gallery') gallery: DxGalleryComponent;

  @Input() public Visible: boolean;
  @Input() public Incident: IncidentDto;
  @Input() public readOnly: boolean = false;
  @Output() onClosed = new EventEmitter();

  public ImportErrors: string[] = null;
  public ImportPhotoUrl: string = null;
  public ImportPhotoHeaders = null;

  height: number;

  parametres: ParametreDto[] = [];
  utilisePhotoPda = false;
  photoPopupVisible = false;

  @Select(VisitesStore.photosIncident$) photos$: Observable<IncidentPhotoDto[]>;
  public photos = [];

  constructor(
    private envService : EnvService,
    private store: Store,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private controlPanelService: ControlPanelService,
    private notificationService: NotificationService
  ) {
    super(controlPanelService, PermissionPrefix.Incident);
    this.ImportPhotoHeaders = this.controlPanelService.requestHeader;
  }

  ngOnInit(): void {
    this.Subscriptions.push(this.photos$.subscribe(p => {
      if (p) {
        this.photos = p.map( p => this.envService.apiUrl + '/api/incidents/photos/' + p.Id );
      }
    }));

    this.Subscriptions.push(this.parametres$.subscribe(res => {
      if(res != null) {
        this.parametres = res;

        let paramUtilisePhotoPda = this.parametres.filter(p => p.Nom == ParametreValues[ParametreValues.PrisePhotoPDA]);
        if(paramUtilisePhotoPda.length > 0) {
          this.utilisePhotoPda = paramUtilisePhotoPda[0].Valeur.toLowerCase() == "true";
        }
      }
    }));
  }

  onShowing() {
    this.photos = [];
  }

  onShown() {
    this.height = this.readOnly ? 460 : 600;
    this.ImportPhotoUrl = this.envService.apiUrl + '/api/incidents/' + this.Incident.Id + '/photo';
    this.store.dispatch(new Visites.GetIncidentPhotos(this.Incident.Id));
  }

  ImportError($event) {
    this.loaderService.FinishLoad();
    this.notificationService.displayMessage(TypeMessage.error, this.translate.instant('Incidents.Photos.ImportError'));
    this.ImportErrors = JSON.parse($event.error.responseText);
  }

  ImportComplete($event) {
    this.loaderService.FinishLoad();
    this.store.dispatch(new Visites.GetIncidentPhotos(this.Incident.Id));
  }

  getGalleryHeight() {
    return window.innerHeight * 0.4;
  }

  getGalleryWidth() {
    return window.innerWidth * 0.4;
  }

  closeClicked() {
    this.Visible = false;
    this.onClosed.emit();
  }

  popupClicked() {
    this.photoPopupVisible = true;
  }

  onPhotoPopupClosed(data: number[]) {
    this.photoPopupVisible = false;
    if(data) {
      this.store.dispatch(new Visites.AddIncidentPhotoPDA(this.Incident.Id, data)).subscribe(res => {
        if (res.visites.error == null) {
          this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Parcs.Photos.Notification.AddSuccess'));
          //this.store.dispatch(new Visites.GetPhotos(this.intervention.Id));
          this.store.dispatch(new Visites.GetIncidentPhotos(this.Incident.Id)).subscribe(res => {
            this.gallery.instance.repaint();
          });
        }
        else {
          this.notificationService.displayMessage(TypeMessage.error, this.translate.instant('Parcs.Photos.Notification.AddError'));
        }
      });
    }
  }

}
